import { useEffect, useState, useRef, useCallback } from 'react';
function useCopy() {
    const [didCopy, setDidCopy] = useState(false);
    const timeoutRef = useRef(null);
    const onCopy = useCallback((e) => {
        // Need to prevent the click from flowing through to the parent
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setDidCopy(true);
        // Create dummy element to be able to access clipboard
        const dummy = document.createElement('input');
        const text = window.location.href;
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => setDidCopy(false), 2000);
    }, []);
    // same as componentWillUnmount
    useEffect(() => {
        return function () {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    return { onCopy, didCopy };
}
export default useCopy;
//# sourceMappingURL=useCopy.js.map